import { Form } from 'react-bootstrap';
import { FeedbackProps } from 'react-bootstrap/esm/Feedback';
import { useFormContext } from 'react-hook-form';

export const FeedbackWithContext = (
  props: FeedbackProps & {
    controlId: string;
  },
) => {
  const {
    formState: { errors },
  } = useFormContext();
  const { controlId, ...rest } = props;
  return (
    <Form.Control.Feedback style={{ display: [controlId] ? 'block' : 'none' }} {...rest}>
      {errors[controlId]?.message as string}
    </Form.Control.Feedback>
  );
};
